export default "__VITE_ASSET__0XhoP8vu__"